import { useState } from "react";
import { Avatar, Divider } from "antd";
import { useSelector, shallowEqual } from "react-redux";
import { DownOutlined, UserOutlined } from "@ant-design/icons";

import { ProfilePopover } from "../Popover";
import getFirstAlphabet from "@/utils/getFirstAlphabet";
import NotificationPopover from "./NotificationPopover";

const LoggedInUserMenu = ({ isMobile }) => {
  const [showProfilePopover, setShowProfilePopover] = useState(false);

  const { userInfo, firstName, lastName } = useSelector(
    (state) => ({
      userInfo: state.user.userInfo,
      firstName: state.user.userInfo?.firstName,
      lastName: state.user.userInfo?.lastName
    }),
    shallowEqual
  );

  const onClickProfileIcon = () => setShowProfilePopover(true);
  const fullName = [firstName, lastName].filter(Boolean).join(" ");

  return (
    <>
      {!isMobile && <NotificationPopover />}
      {!isMobile && <Divider type="vertical" className="border-white h-6" />}
      <div
        className="relative cursor-pointer !p-0 w-fit flex items-center gap-2 text-white hover:!text-white"
        onClick={onClickProfileIcon}>
        <Avatar
          className={`${
            isMobile
              ? "bg-[#7367F0] w-[54px] h-[54px]"
              : "border border-solid border-white font-manropeMedium !text-base w-[36px] h-[36px]"
          } rounded-full cursor-pointer`}
          src={userInfo?.profilePictureUrl}
          size="large"
          alt="user-profile-picture"
          icon={
            firstName ? getFirstAlphabet(firstName, lastName) : <UserOutlined />
          }
        />
        {!isMobile && (
          <>
            <div className="font-manropeMedium">{fullName}</div>
            <DownOutlined className="text-xs" />
          </>
        )}

        {isMobile && (
          <div className="absolute -bottom-1 left-9 w-[14px] h-[14px] bg-[#28C76F] border-2 border-white rounded-full z-10" />
        )}
        {isMobile && (
          <div className="text-white text-lg font-bold">{fullName}</div>
        )}
      </div>

      <ProfilePopover
        visible={showProfilePopover}
        setVisibility={setShowProfilePopover}
        placement="bottomRight"
      />
    </>
  );
};

export default LoggedInUserMenu;
